import { render, staticRenderFns } from "./HouseNavigation.vue?vue&type=template&id=f3c9fe22&scoped=true"
import script from "./HouseNavigation.vue?vue&type=script&lang=js"
export * from "./HouseNavigation.vue?vue&type=script&lang=js"
import style0 from "./HouseNavigation.vue?vue&type=style&index=0&id=f3c9fe22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c9fe22",
  null
  
)

export default component.exports